import axios from 'axios';
import { Encrypt } from '../utils/encryption';
import { userManagementApi } from '../config/api';

const headers = { 'Content-Type': 'application/json' };

/** Uses FrontendTouchPoint `handlePassword` with action `changePasswordAuthenticated`. */
export async function changePasswordAuthenticated(
  token,
  currentPassword,
  newPassword
) {
  const res = await axios.post(
    userManagementApi,
    {
      ...Encrypt({
        token,
        currentPassword,
        newPassword,
        action: 'changePasswordAuthenticated',
      }),
      operationType: 'resetpassword',
    },
    { headers }
  );
  return res.data;
}
